const superPx = 2;

export const units = (step: number) => `${step * superPx}px`;
